/**
 * Tab switcher. Uses ARIA attributes so it remains accessible.
 */

import { allByHook } from '../dom.js';

export const createTabs = (root, { onChange } = {}) => {
    const buttons = allByHook('tab', root);
    const panels = allByHook('panel', root);

    const activate = (name) => {
        buttons.forEach((btn) => {
            const matches = btn.dataset.marcTab === name;
            btn.classList.toggle('marc__tab--active', matches);
            btn.setAttribute('aria-selected', matches ? 'true' : 'false');
            btn.tabIndex = matches ? 0 : -1;
        });
        panels.forEach((panel) => {
            const matches = panel.dataset.marcPanel === name;
            panel.classList.toggle('marc__panel--active', matches);
            panel.hidden = !matches;
        });
        onChange?.(name);
    };

    buttons.forEach((btn) => {
        btn.addEventListener('click', () => activate(btn.dataset.marcTab));
        btn.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            const index = buttons.indexOf(event.currentTarget);
            const next =
                event.key === 'ArrowRight'
                    ? (index + 1) % buttons.length
                    : (index - 1 + buttons.length) % buttons.length;
            buttons[next].focus();
            activate(buttons[next].dataset.marcTab);
        });
    });

    return { activate };
};
